// src/pages/Enquiries.js
import React from 'react';
import EnquiriesPage from '../components/enquiries';

const Enquiries = () => {
  return <EnquiriesPage />;
};

export default Enquiries;